

module.exports = __webpack_require__.stylable.create(
    "Popover4073012529",
    {"classes":{"root":"Popover4073012529__root","arrow":"Popover2386893271__arrow","withArrow":"Popover2386893271__withArrow"},"vars":{},"stVars":{"contentArrowSize":"8px"},"keyframes":{}},
    "",
    2,
    "Popover4073012529",
    null
);
